export const VALIDATION = 'validation';
export const KV_PAIR = 'kvPair';
export const IA_ACCREDITATION_MAPPING = 'accreditationmapping';
export const INSUFFICIENCY_SUPPORT = 'insufficiencySupport';
export const INSUFFICIENCY_REVIEW = 'insufficiencyReview';
export const COMMON = 'common';
export const VENDOR = 'vendor';
export const VERIFIER = 'verifier';
export const ONBOARDING = 'onboarding';
export const DASHBOARD = 'dashboard';
export const TEAM_MEMBER_LOCALE_KEY = 'teamMembers';
export const ISSUING_AUTHORITY_MAP = 'issuingAuthorityMap';
export const ISSUING_AUTHORITY_DATABASE = 'issuingAuthorityDatabase';
export const ACCREDITATION = 'accreditation';
export const DATA_TAMPERING_ANALYSIS = 'dataTamperingAnalysis';
export const TASKS = 'tasks';
export const FINANCE = 'finance';
export const AUDIT = 'audit';
export const SUPPORT = 'support';
export const TRACK_CASE = 'trackCase';
export const ANALYTICS = 'analytics';
export const PENDING_CLAIMS = 'pendingClaims';
export const CLIENT_CONTRACT = 'client-contract';
export const GLOBAL_CORRUPTION_INDEX = 'globalCorruptionIndex';
export const AVAILABLE_LANGUAGES = {
  en: 'en',
  ar: 'ar'
};

export const LANGUAGES_PARAMS_KEY_NAME = 'lang';
export const DEFAULT_LNG = AVAILABLE_LANGUAGES.en;
export const LANGUAGES = [AVAILABLE_LANGUAGES.en /*AVAILABLE_LANGUAGES.ar*/];
export const DEFAULT_NS = 'common';
export const COOKIE_NAME = 'portalLang';
export const SKIP_TASK_BUTTON = 'skipTaskButton';
export const VERIFICATION = 'verification';
export const CASE_ENTRY = 'caseEntry';
